module.exports = __webpack_public_path__ + "img/shortcut_app_off.a3b520a7.svg";